module.exports = __webpack_public_path__ + "static/media/diktat-16.c48e4de2.mp3";